import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=ca2b13d6&scoped=true&"
import script from "./indexPage.vue?vue&type=script&lang=js&"
export * from "./indexPage.vue?vue&type=script&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=ca2b13d6&lang=scss&scoped=true&"
import style1 from "./indexPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2b13d6",
  null
  
)

export default component.exports